import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import React, { Component } from 'react';
import { css } from 'styled-components';
import { Transition } from 'react-transition-group';
import { noop } from 'lodash';
import { createComponent } from '../utils';
var getTransitionStyle = function (state, duration) {
    switch (state) {
        case 'exited':
            return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: none;\n      "], ["\n        display: none;\n      "])));
        case 'entering':
        case 'exiting':
            return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        transition: height ", "ms ease-in-out;\n        overflow: hidden;\n      "], ["\n        transition: height ", "ms ease-in-out;\n        overflow: hidden;\n      "])), duration);
        default:
            return css(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
    }
};
var Container = createComponent({
    name: 'Collapse',
    style: function (_a) {
        var duration = _a.duration, height = _a.height, state = _a.state;
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: relative;\n    height: ", "px;\n\n    ", ";\n  "], ["\n    position: relative;\n    height: ", "px;\n\n    ", ";\n  "])), height, getTransitionStyle(state, duration));
    },
});
var Trigger = createComponent({
    name: 'CollapseTrigger',
});
var Collapse = (function (_super) {
    __extends(Collapse, _super);
    function Collapse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: _this.props.isOpen || false,
            height: 0,
        };
        _this.onEnter = function (node, isAppearing) {
            _this.props.onEnter(node, isAppearing);
        };
        _this.onEntering = function (node, isAppearing) {
            _this.setState({ height: node.scrollHeight });
            _this.props.onEntering(node, isAppearing);
        };
        _this.onEntered = function (node, isAppearing) {
            _this.setState({ height: node.scrollHeight });
            _this.props.onEntered(node, isAppearing);
        };
        _this.onExit = function (node) {
            _this.setState({ height: node.scrollHeight });
            _this.props.onExit(node);
        };
        _this.onExiting = function (node) {
            _this.setState({ height: 0 });
            _this.props.onExiting(node);
        };
        _this.onExited = function (node) {
            _this.props.onExited(node);
        };
        _this.toggle = function () {
            _this.setState(function (state) { return ({
                isOpen: !state.isOpen,
            }); });
        };
        return _this;
    }
    Collapse.getDerivedStateFromProps = function (props, state) {
        if (props.isOpen !== undefined && props.isOpen !== state.isOpen) {
            return __assign(__assign({}, state), { isOpen: props.isOpen });
        }
        return null;
    };
    Collapse.prototype.renderTrigger = function () {
        var _a = this.props, trigger = _a.trigger, renderTrigger = _a.renderTrigger;
        if (renderTrigger) {
            return renderTrigger({ toggle: this.toggle });
        }
        if (trigger) {
            return React.createElement(Trigger, { onClick: this.toggle }, trigger);
        }
        return null;
    };
    Collapse.prototype.render = function () {
        var _a = this.props, duration = _a.duration, children = _a.children, props = __rest(_a, ["duration", "children"]);
        var _b = this.state, height = _b.height, isOpen = _b.isOpen;
        return (React.createElement(React.Fragment, null,
            this.renderTrigger(),
            React.createElement(Transition, __assign({}, props, { in: isOpen, timeout: duration, onEnter: this.onEnter, onEntering: this.onEntering, onEntered: this.onEntered, onExit: this.onExit, onExiting: this.onExiting, onExited: this.onExited }), function (state) { return (React.createElement(Container, { state: state, height: height, duration: duration }, children)); })));
    };
    Collapse.defaultProps = {
        duration: 175,
        onEnter: noop,
        onEntering: noop,
        onEntered: noop,
        onExit: noop,
        onExiting: noop,
        onExited: noop,
    };
    return Collapse;
}(Component));
export default Collapse;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Collapse.js.map